import { useState } from 'react';
import { useStore, useStoreActions } from "../../contexts";
import { useOnMount } from "../useOnMount";
import { wait } from "../../infra/utils";
import { selectors } from "../../store/state-selectors";
import { useIsMounted } from "../useIsMounted";
import { invoiceModel } from "../../models";
import { useFeatureFlags } from "../useFeatureFlags";
const POLLING_TIMEOUT = 2 * 60 * 1000; // 2min in ms

export function useInvoiceStateWithPollingForQbo(initialInvoice) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const isMounted = useIsMounted();
  const {
    api
  } = useStoreActions();
  const qboPollingInterval = useStore(state => state.appConfig.qboPollingInterval);
  const isVendor = useStore(selectors.user.isVendor);
  const [hasError, setHasError] = useState(false);
  const [invoice, setInvoice] = useState(initialInvoice);
  const {
    USE_INVOICE_VIEWS = false
  } = useFeatureFlags();
  useOnMount(() => {
    if (!options.disableReloadOnMount && !invoiceModel.isStableIntegrationStatus(invoice)) {
      wait(qboPollingInterval).then(() => reloadInvoice());
    }
  });

  async function reloadInvoice() {
    try {
      setHasError(false);
      const newInvoice = await reloadInvoiceWithPollingForQbo();
      isMounted() && setInvoice(newInvoice);
      return newInvoice;
    } catch (err) {
      isMounted() && setHasError(true);
      throw err;
    }
  }

  async function reloadInvoiceWithPollingForQbo() {
    const start = Date.now();
    let newInvoice = await (USE_INVOICE_VIEWS ? api.invoice.getByIDScout(invoice.id, !isVendor) : api.invoice.getByID(invoice.id, !isVendor)); // Keep polling until the invoice reaches a stable integration status.

    while (isMounted() && !invoiceModel.isStableIntegrationStatus(newInvoice) && Date.now() - start < POLLING_TIMEOUT) {
      await wait(qboPollingInterval);
      newInvoice = await (USE_INVOICE_VIEWS ? api.invoice.getByIDScout(invoice.id, !isVendor) : api.invoice.getByID(invoice.id, !isVendor));
    }

    return newInvoice;
  }

  return {
    hasError,
    invoice,
    setInvoice,
    reloadInvoice
  };
}